import { ChangeEvent, useEffect, useState } from "react";
import { Todo } from "../models/Todo";

interface ITodoItem {
  todo: Todo;
  updateTodo(todo: Todo): void;
  removeTodo(todo: Todo): void;
}

function TodoItem(props: ITodoItem) {
  const [todo, setTodo] = useState<Todo>(props.todo);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "isDone")
      setTodo({ ...todo, [e.target.name]: !todo.isDone });
    else setTodo({ ...todo, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (todo.title === "") {
      props.removeTodo(todo);
    } else {
      props.updateTodo(todo);
    }
  }, [todo]);

  return (
    <div className="cursor-grabbing bg-white rounded-md border mb-3 p-3 w-full flex justify-between items-center px-6">
      <div className="flex space-x-6 items-center">
        <input
          className="cursor-pointer"
          name="isDone"
          type="checkbox"
          checked={todo.isDone}
          onChange={handleChange}
        />
        <div>
          <input
            className="w-full"
            name="title"
            type="text"
            value={todo.title}
            onChange={(e) => handleChange(e)}
          />
          <p className="text-sm text-gray-400">created</p>
        </div>
      </div>
      <div>
        <button
          className="hover:bg-gray-100 p-2 px-5 text-sm rounded-md font-semibold"
          onClick={() => props.removeTodo(props.todo)}
        >
          Remove
        </button>
      </div>
    </div>
  );
}

export default TodoItem;
